import Hero from '../components/Hero';
import Features from '../components/Features';
import SupportSection from '../components/SupportSection';
import AdditionalSections from '../components/AdditionalSections';
import SystemRequirements from '../components/SystemRequirements';
import Testimonials from '../components/Testimonials';
import SupportIssues from '../components/SupportIssues';
import Footer from '../components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#fafafa]">
      <Hero />
      <Features />
      <SupportSection />
      <AdditionalSections />
      <SystemRequirements />
      <Testimonials />
      <SupportIssues />
      <Footer />
    </div>
  );
}
